import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import store, { toggleMenu } from '../../../state';

import './menu.css';

function hideBurgerMenu() {
  store.dispatch(toggleMenu(false));
}

function renderMenuItem(item, idx) {
  let link = null;
  if (item.type === 'node') {
    const url = item.nodeType === 'project-listing' ? `/works/${item.node}` : `/${item.node}`;
    link = <Link to={url} onClick={hideBurgerMenu}>{item.title}</Link>;
  } else if (item.type === 'heading') {
    link = <h4>{item.title}</h4>;
  }

  let children = null;
  if (item.children) {
    children = <ul>{item.children.map(renderMenuItem)}</ul>;
  }

  const key = `${item.type}-${idx + 1}`;

  return (
    <li key={key}>
      {link}
      {children}
    </li>
  );
}

const Menu = ({ menu }) => (
  <div className="menu">
    <ul>
      {menu.map(renderMenuItem)}
    </ul>
    <div className="copyright">Images used with permission from the artist &copy;2018 DCG Design</div>
  </div>
);

Menu.propTypes = {
  menu: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  menu: state.getIn(['menu', 'items']).toJS(),
});

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/header/menu/index.jsx